import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Switch from '../../common/inputs/customs/switch.jsx';

class MultipleModeratorsMode extends Component {
  render() {
    const { isMultipleModeratorsMode, onChange } = this.props;
    return (
      <div>
        <Switch
          title="Multiple Moderators Mode"
          description={
            'Enable multiple moderators to moderate incoming messages in parallel and separately from one another.'
          }
          value={isMultipleModeratorsMode}
          onChange={onChange}
        />
      </div>
    );
  }
}

MultipleModeratorsMode.defaultProps = {
  isMultipleModeratorsMode: false
};

MultipleModeratorsMode.propTypes = {
  isMultipleModeratorsMode: PropTypes.bool.isRequired,
  spotId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

MultipleModeratorsMode.contextTypes = {
  executeAction: PropTypes.func.isRequired
};

MultipleModeratorsMode.displayName = 'MultipleModeratorsMode';

export default MultipleModeratorsMode;
